"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XLSXClient = void 0;
var fs = _interopRequireWildcard(require("node:fs"));
var _nodeStream = require("node:stream");
var XLSX = _interopRequireWildcard(require("xlsx"));
var _types = require("./types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class XLSXClient {
  static typeMap = new Map([["b", _types.CellType.Boolean], ["d", _types.CellType.Date], ["e", _types.CellType.Error], ["n", _types.CellType.Number], ["s", _types.CellType.String], ["z", _types.CellType.Empty]]);
  constructor() {
    XLSX.set_fs(fs);
    XLSX.stream.set_readable(_nodeStream.Readable);
  }
  streamRows(filePathOrBuffer, sheet) {
    let workbook;
    if (Buffer.isBuffer(filePathOrBuffer)) {
      workbook = XLSX.read(filePathOrBuffer, {
        dense: true,
        sheets: sheet
      });
    } else {
      workbook = XLSX.readFile(filePathOrBuffer, {
        dense: true,
        sheets: sheet
      });
    }
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const stream = _nodeStream.Readable.from(worksheet["!data"]);
    let index = 0;
    return stream.map(data => this.toExcelRow(data, ++index));
  }
  toExcelRow(data, index) {
    let isEmpty = true;
    const cells = [];
    for (const cellData of data) {
      if (cellData == null || cellData.t == _types.CellType.Empty) {
        cells.push({
          raw: cellData?.w ?? "",
          type: _types.CellType.Empty,
          value: undefined
        });
      } else {
        isEmpty = false;
        cells.push({
          raw: cellData.w ?? "",
          type: XLSXClient.typeMap.get(cellData.t) ?? _types.CellType.Unknown,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          value: cellData.v
        });
      }
    }
    return {
      cells,
      index,
      isEmpty
    };
  }
}
exports.XLSXClient = XLSXClient;